import { request } from "@/nano";

/**
 * 获取用户信息
 * @param data 数据
 */
export function queryUmsUserById(data) {
    return request.post({
        url: "/api/ums/umsUser/queryUmsUserById",
        method: "post",
        data,
    });
};

/**
 * 修改用户信息
 * @param data 数据
 */
export function updateById(data) {
  return request.post({
      url: "/api/ums/umsUser/updateUmsUserById",
      method: "post",
      data,
  });
};

/**
 * 保存
 * @param data 数据
 */
// export function save(data) {
//   return request.post({
//     url: "/api/admin/updateLoginPassword/save",
//     method: "post",
//     data,
//   });
// };

/**
 * 更新
 * @param data 数据
 */
// export function update(data) {
//   return request.post({
//     url: "/api/admin/updateLoginPassword/update",
//     method: "post",
//     data,
//   });
// };

/**
 * 修改密码
 * @param data 数据
 */
export function updatePassword(data) {
  return request.post({
    url: "/api/ums/umsUser/updateUmsUserPassword",
    method: "post",
    data,
  });
};

/**
 * 修改头像
 * @param data 数据
 */
export function updateAvatar(data) {
  return request.post({
    url: "/api/ums/umsUser/updateUmsUserAvatar",
    method: "post",
    data,
  });
}
